<template>
  <v-dialog width="80%" v-model="dialog" persistent @keydown.esc="done">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t("tests.test.chooseLanguage") }}</span>
        <v-spacer />
        <v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="px-12 pb-0">
        <v-row align="center" justify="center">
          <v-col>
            <v-row align="center" justify="center">
              <v-col class="text-center">
                <v-icon color="warning" size="75">warning</v-icon>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col class="text-center">
                <span class="headline">{{ $t("tests.test.noLocale") }}</span>
              </v-col>
            </v-row>
            <v-row align="end" justify="center">
              <v-col class="text-center">
                <span class="headline">{{
                  $t("tests.test.solveTestInLanguage")
                }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-12">
        <v-spacer />
        <template v-for="locale in testLocales">
          <v-btn
            :key="locale"
            color="primary"
            @click="$emit('selected', locale)"
            >{{ locales.find((l) => l.value == locale).text }}</v-btn
          >
        </template>

        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["show", "testLocales"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["locales"]),

    dialog() {
      return this.show;
    },
  },
};
</script>